// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel {
    'type'?: string | null;
    'subject'?: string | null;
    'body'?: string | null;
    'dueDate'?: Moment;
    'accountId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel>> = [
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "subject",
            "baseName": "subject",
            "type":     "string"
        },
        {
            "name":     "body",
            "baseName": "body",
            "type":     "string"
        },
        {
            "name":     "dueDate",
            "baseName": "dueDate",
            "type":     "Date"
        },
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel.attributeTypeMap;
    }
}
